import { render, staticRenderFns } from "./OddsExpandibleCard.vue?vue&type=template&id=ee19ced2&scoped=true"
import script from "./OddsExpandibleCard.vue?vue&type=script&lang=ts"
export * from "./OddsExpandibleCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee19ced2",
  null
  
)

export default component.exports